export default "__VITE_ASSET___kr09xTf__"